import { createFileRoute } from "@tanstack/react-router";
import AdminTagNewPage from "@/pages/admin/tags/new";
import { useTagsPermissions } from "@/pages/admin/tags";

export const Route = createFileRoute("/app/admin/tags/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { userCanEditAllTags, userCanViewAllTags } = useTagsPermissions();

  return (
    <AdminTagNewPage
      userCanEditAllTags={userCanEditAllTags}
      userCanViewAllTags={userCanViewAllTags}
    />
  );
}
